import { gql } from '@apollo/client'

export const Query = gql`
  query CompanyUsers(
    $companyId: ID!,
    $filters: CompanyUserFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    companyUsers(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        user { id name }
        initiatedBy { id name }
        acceptedAt
        role
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
